import "./Projects.css";
import React from "react";
import Project from "./Project/Project";
import "./Projects.css";
import demsImage from "../../images/demsteam.png";
import melaImage from "../../images/ecommerce-mela.webp";
import proqImage from "../../images/proq.png";
import splenperImage from "../../images/splenper.jpg";
import aiFundsManagementImage from "../../images/aifunds.jpg";
const Projects = () => {
  
  const AiFundsManagementTechStack = [
    "Tailwind css",
    "JavaScript",
    "NextJs-14",
    "Postgres Database",
    "OpenAI",
    "Stock API",
    "Custom Chat-bot",
    "Vercel",
    "Github",
  ];
  const SplenperTechStack = [
    "HTML",
    "CSS",
    "JavaScript",
    "React-Js",
    "Postgres Database",
    "Strapi CMS",
    "Prisma ORM",
    "Tailwind css",
    "Schadcn UI",
    "Expo (React Native)",
    "Firebase",
    "Payriff Payment Gateway",
    "Vercel",
    "Github",
  ];


    const DemsTechStack = [
      "HTML",
      "CSS",
      "JavaScript",
      "React-Js",
      "MySQL",
      "Sequelize",
      "Bootstrap",
      "Styled Components",
      "Express",
      "Node JS",
      "Netlify",
      "Github",
    ];
  const MelaTechStack = [
    "HTML",
    "CSS",
    "JavaScript",
    "React-Js",
    "Bootstrap-5",
    "Chart.js",
    "Redux",
    "React Redux",
    "MongoDb",
    "Express",
    "Node JS",
    "Vercel",
    "Github",
  ];


  const ProqTechStack = [
    "Tailwind css",
    "React-Js",
    "NextJs-14",
    "Redux",
    "React Redux",
    "MongoDb",
    "Node JS",
    "Vercel",
    "Github",
    "Restful Apis"
  ];
  return (
    <section className={`projects`} id="projects">
      <div className="project-text">
        <h1>My Projects / Work</h1>
        <br />
        <span>
          Using the latest Technologies showcasing Professional Projects and
          Industrial work.
        </span>
      </div>
      <div className="allProjects">
        <Project
          title="Splenper"
          description="Splenper is a platform allowing influencers and business/brands to collaborate/barter on sponsored posts and campaigns via instagram/tiktok content. Businesses can find and select influencers for their campaigns, can send them offers and influencers can accept or reject the offers. Influncers can earn money by posting sponsored content. Influencers can withdraw their earnings via bank transfer ."
          techName={SplenperTechStack}
          coverPhoto={splenperImage}
          links={[
            { label: "Business Dashboard", url: "https://app.splenper.com/dashboard" },
            { label: "Main Website", url: "https://splenper.com/" },
            { label: "iOS App", url: "https://apps.apple.com/us/app/splenper/id6746457726" },
            { label: "Android App", url: "https://play.google.com/store/apps/details?id=com.app.splenper&hl=en" }
          ]}
        />
        <Project
          title="AI Funds Manager"
          description="Monitor your financial instruments and track your holdings with investing.com portfolios. Monitor your portfolio holdings and performance. Access your watchlist via PC, Tablets or Phone. Track multiple watchlists. Include stocks, funds, indexes, currencies and commodities. Add to your portfolio from each instrument page or from within the portfolio itself"
          techName={AiFundsManagementTechStack}
          coverPhoto={aiFundsManagementImage}
          liveLink="https://aifund.fictiondevelopers.com/"
        />
        <Project
          title="Demsteam"
          description="Demsteam (Digital Explorers Marketing Serivces) is a successful
          platform that I created to provide professional services like Ad
          campaigns, SEO, Google PPC, Social Media Managment, Marketing
          Automation, Ecommerce, Assisted Living and many more."
          techName={DemsTechStack}
          coverPhoto={demsImage}
          liveLink="https://demsteam.netlify.app/"
        />
        <Project
          title="Mela Ecommerce Store"
          description="Mela is a successful online ecommerce platform that I created for listing & selling accessories, goods, households and other ecommerce products.Additionally this store also has an Admin Pannel for products, orders and user managment."
          techName={MelaTechStack}
          coverPhoto={melaImage}
          liveLink="https://mela-store.vercel.app/"
        />
        <Project
          title="ProQ - Online Appointments Scheduling"
          description="ProQ is a successful online appointments booking web application that contains booking related to all kind of professoins like events, beauty saloons, workshops, doctors, rental places and many more."
          techName={ProqTechStack}
          coverPhoto={proqImage}
          liveLink="https://proq.vercel.app/"
        />
      </div>
    </section>
  );
};

export default Projects;
